import { render } from "./CompareProducts.vue?vue&type=template&id=28b1787e"
import script from "./CompareProducts.vue?vue&type=script&lang=js"
export * from "./CompareProducts.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__